import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/checkingRules'
import { EditCheckingRuleDialog } from './dialog'

class EditCheckingRuleDialogShell extends React.Component {
  componentDidMount () {
    this.props.get(this.props.id)
  }
  render () {
    const { checkingRule, fetching, updating, closeDialog, title, componentKey, disabled } = this.props
    return (
      <EditCheckingRuleDialog
        key={componentKey}
        disabled={disabled}
        checkingRule={checkingRule}
        loading={fetching || updating}
        closeDialog={closeDialog}
        title={title}
        onAction={dto => {
          this.props.save(dto, () => this.props.closeDialog())
        }}
      />
    )
  }
}

function mapStateToProps (state) {
  return {
    ...state.checkingRules
  }
}

const mapDispatchToProps = {
  get: actionCreators.get,
  save: actionCreators.save
}

export default {
  component: connect(mapStateToProps, mapDispatchToProps)(EditCheckingRuleDialogShell),
  modalProps: { size: 'lg' }
}



// WEBPACK FOOTER //
// ./src/dialogs/editCheckingRule/index.js